import { TypedContainer } from "./_Base";
export class GlContainer extends TypedContainer {
  object() {
    return this._content;
  }
}
